export default __webpack_public_path__ + "static/caramel-eyelet-39a09ec462835652424ac456b05e6b59.webp";